var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23447 5.83441C4.3845 5.68443 4.58794 5.60018 4.80007 5.60018C5.0122 5.60018 5.21565 5.68443 5.36567 5.83441L8.00007 8.46881L10.6345 5.83441C10.7083 5.758 10.7965 5.69706 10.8941 5.65513C10.9918 5.6132 11.0967 5.59113 11.203 5.59021C11.3092 5.58929 11.4145 5.60953 11.5128 5.64975C11.6112 5.68998 11.7005 5.74938 11.7756 5.82449C11.8507 5.89961 11.9101 5.98893 11.9503 6.08725C11.9906 6.18556 12.0108 6.29091 12.0099 6.39713C12.009 6.50335 11.9869 6.60833 11.945 6.70593C11.903 6.80354 11.8421 6.89181 11.7657 6.96561L8.56567 10.1656C8.41565 10.3156 8.2122 10.3998 8.00007 10.3998C7.78794 10.3998 7.5845 10.3156 7.43447 10.1656L4.23447 6.96561C4.0845 6.81559 4.00024 6.61214 4.00024 6.40001C4.00024 6.18788 4.0845 5.98443 4.23447 5.83441Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/ChevronDown.f921132e593d787360dd076a0508e3cd.svg";
export { ForwardRef as ReactComponent };